<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex-composition-helpers'

const props = defineProps<{
  value: number | null
  job: object
}>()

const store = useStore()
const scadaUnits = computed<string>(() => store.state.organizationConfig.scadaUnits ?? '')

const formatted = computed(() => {
  if (props.value == null) return ''
  return `${props.value.toFixed(2)} ${scadaUnits.value}`
})
</script>

<template>
  <span>{{ formatted }}</span>
</template>
